import React from 'react';
import "./index.less"

const Schedule = (props) => {
    const {active = 0} = props;

    return (
        <div className="schedule-wrap1">
            <div className="schedule-wrap-card">
                {
                    [1,2,3,4,5,6,7,8,9,10].map((item) => {
                        return <div className={`schedule-item ${item <= active ? 'active' : ''}`} key={`sch1${item}`}></div>
                    })
                }
            </div>
            <div className="schedule-wrap1-score">{active}</div>
        </div>
    )
};

export default Schedule;